export const getMarketLanguageTranslations = (marketLanguageTags: string[], translations: Record<string, string>) =>
	Object.fromEntries(marketLanguageTags.map((languageTag) => [languageTag, translations[languageTag] ?? ""]))
